import { encryptLeads } from "@repo/shared-utils/crypto";
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import type { SSORedirectHandler } from "../types/SSO.types";

export const bfslHandler: SSORedirectHandler = async (data) => {
  const url = data.mapping.newUrl;
  const filteredData = {
    screen: data.data?.screen,
    token: data.data?.token ? String(data?.data?.token) : "",
    symbol: data.data?.symbol,
    action: data.data?.action,
    mobileNo: data.data?.mobileNo,
  };

  const dataString = JSON.stringify(filteredData);
  const leadsDetailEncrypted = await encryptLeads(dataString);
  url.searchParams.append("req", leadsDetailEncrypted);
  url.searchParams.append("utm_source", "widget");
  url.searchParams.append("utm_medium", "organic_bfl");
  url.searchParams.append("utm_campaign", window.location.href.split("/").pop() ?? "");
  if (isOpenInApp()) {
    const payload = {
      url: url,
      title: data?.data?.headerName || "Bajaj Broking",
    };
    window.prompt(`openInAppWebViewActivity://${JSON.stringify(payload)}`);
  } else {
    window.open(url, data.target);
  }
};
